import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;
  position: relative;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 0;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 3em;

  .ant-spin-nested-loading {
    z-index: 11;
  }
`;

export const SearchPlaceholderWrapper = styled.div`
  position: absolute;
  top: 30%;
  left: 30%;
`;

export const NoResultPlaceholderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 75vh;
`;

export const QuickSearchIcon = styled.img`
  height: 200px;
  width: 100%;
`;

export const NoResultsFoundIcon = styled.img`
  height: 200px;
  width: 100%;
`;

export const ApplicantStatusContainer = styled.div`
  display: flex;
`;

export const ApplicantStatusIn = styled.div`
  color: #8c8c8c;
  font-style: italic;
  font-family: Roboto;
  margin-right: 0.5rem;
`;

export const ApplicantStatus = styled.div`
  color: #00918e;
  cursor: pointer;
`;

export const InputContainer = styled.div`
  .ant-input-affix-wrapper {
    &:hover,
    &:focus,
    &:active,
    &:hover:disabled {
      border: 1.6px solid ${theme.colors.secondary} !important;
    }
  }
  .ant-input-suffix {
    margin-top: 6px;
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 57px);
`;

export const StarIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 12px;
  margin-bottom: 3px;
`;

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
`;
